<template>
    <pc-alert
        v-bind:shown="true"
        v-bind:severity="alertSeverity">
        <div>
            <div class="mb-3">
                {{ infoMessage }}
            </div>
            <pc-expand-list
                v-bind="expandListCommonBinder"
                v-bind:items="createTagsResultModel.AddedSignatories"
                key-prop-getter="PublicId"
                v-bind:header="addedSignatoriesHeader" />
            <pc-expand-list
                v-bind="expandListCommonBinder"
                v-bind:items="createTagsResultModel.RemovedSignatories"
                key-prop-getter="PublicId"
                v-bind:header="removedSignatoriesHeader" />
            <pc-expand-list
                v-bind="expandListCommonBinder"
                v-bind:items="createTagsResultModel.AssociatedESignatureNames"
                key-prop-getter="PublicId"
                v-bind:header="associatedESignatureEnvelopesHeader" />
        </div>
    </pc-alert>
</template>
<script>
    import { KEYS, NAMESPACE } from "./i18n/signatoryTagErrorsDialog.i18n";
    import { mapI18n } from "Util/i18n";
    import { ALERT_SEVERITY } from "Util/alerts";

    export default {
        props: {
            createTagsResultModel: { type: Object, required: true },
            infoMessage: { type: String, required: false, default: null }
        },
        data() {
            return {
                alertSeverity: ALERT_SEVERITY.error
            };
        },
        computed: {
            ...mapI18n(KEYS, NAMESPACE),
            addedSignatories() {
                return this.createTagsResultModel.AddedSignatories?.length > 0;
            },
            removedSignatories() {
                return this.createTagsResultModel.RemovedSignatories?.length > 0;
            },
            expandListCommonBinder() {
                return {
                    hideIfEmpty: true,
                    class: "mb-2"
                };
            }
        }
    };
</script>
